import { createContext } from 'react';

const ProdutoAppContext = createContext();

export default ProdutoAppContext;
